import React from "react";
import SafeLink from "components/commons/SafeLink";

const ThankYou  = ({message}) => {
  return (
    <div className="thank-you-message">
      <SafeLink><i aria-hidden="true" className="fa fa-thumbs-o-up" /></SafeLink>
      <span>{message}</span>
    </div>
  );
};

export default ThankYou;
